import { AuthModal, useAuthModal } from '@/features/auth'
import { SEO } from '@/shared/components'
import { LANDING_SECTIONS } from '@/config/assets'
import {
  Header,
  HeroSection,
  HowItWorksSection,
  NicolAISection,
  PricingSection,
  FAQSection,
  FinalCTASection,
  Footer,
  LanguageSwitcher,
} from '../components'

/**
 * Landing Page V2
 * Full implementation with all sections
 */
export function LandingPage() {
  const { isOpen, closeAuthModal } = useAuthModal()

  return (
    <div className="min-h-screen bg-white">
      <SEO
        titleKey="seo.landing.title"
        descriptionKey="seo.landing.description"
      />
      {/* Sticky Header */}
      <Header />

      {/* Main Content */}
      <main>
        {/* Hero Section */}
        <section id={LANDING_SECTIONS.hero}>
          <HeroSection />
        </section>

        {/* How It Works Section */}
        <section id={LANDING_SECTIONS.howItWorks}>
          <HowItWorksSection />
        </section>

        {/* NicolAI Section */}
        <section id={LANDING_SECTIONS.nicolai}>
          <NicolAISection />
        </section>

        {/* Pricing Section */}
        <section id={LANDING_SECTIONS.pricing}>
          <PricingSection />
        </section>

        {/* FAQ Section */}
        <section id={LANDING_SECTIONS.faq}>
          <FAQSection />
        </section>

        {/* Final CTA Section */}
        <section id={LANDING_SECTIONS.cta}>
          <FinalCTASection />
        </section>
      </main>

      {/* Footer */}
      <Footer />

      {/* Language Switcher - floating bottom-right */}
      <LanguageSwitcher />

      {/* Auth Modal */}
      <AuthModal isOpen={isOpen} onClose={closeAuthModal} />
    </div>
  )
}
